import { GlyphName } from '@remind/r101-glyphs';
import cx from 'classnames';
import * as React from 'react';

import Glyph from 'components/Glyph';
import MediaObject from 'components/MediaObject';
import Text, { TextColor } from 'components/Text';
// @ts-ignore
import TextWithEntities from 'components/TextWithEntities';
// @ts-ignore
import TextEntities from 'lib/TextEntities';

import './styles/Notice.scss';

export type Props = {
  border?: boolean;
  children: React.ReactNode;
  full?: boolean;
  glyph?: GlyphName;
  height?: number;
  noBorderRadius?: boolean;
  noShadow?: boolean;
} & DefaultProps;

type DefaultProps = {
  color: 'flame' | 'lava' | 'shamrock' | 'pitch' | 'wolf' | 'polar-bear' | 'white' | 'brand';
};

export default class Notice extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    color: 'pitch',
  };

  renderBody() {
    const { children, color, glyph } = this.props;

    let textColor: TextColor = 'white';

    if (color === 'wolf') {
      textColor = 'inherit';
    } else if (color === 'polar-bear' || color === 'white') {
      textColor = 'thunder';
    } else if (color === 'brand') {
      textColor = 'pitch';
    }

    const bodyInner = (
      <Text
        align="left"
        color={textColor}
        weight={color === 'polar-bear' || color === 'white' ? 'normal' : 'semibold'}>
        {typeof children === 'string' ? (
          <TextWithEntities entities={TextEntities.parseEmoji(children)} text={children} />
        ) : (
          children
        )}
      </Text>
    );

    if (glyph) {
      return (
        <MediaObject center gutter="small">
          <Glyph color={color} name={glyph} size="xsmall" solo className="Notice-glyph" />
          {bodyInner}
        </MediaObject>
      );
    } else {
      return bodyInner;
    }
  }

  render() {
    const { border, color, full, height, noBorderRadius, noShadow } = this.props;

    return (
      <div
        style={{ minHeight: height }}
        className={cx('Notice', color && `Notice--${color}`, full && 'Notice--full', {
          'Notice--height': !!height,
        })}>
        <div
          className={cx(
            'Notice-body',
            border && 'Notice-body--border',
            noBorderRadius && 'Notice-body--noBorderRadius',
            noShadow && 'Notice-body--noShadow'
          )}>
          {this.renderBody()}
        </div>
      </div>
    );
  }
}
